/**
 * Record selection for Collections view
 */
class CollectionSelection extends ItemSelection {

	/**
	 * Download btn on batch
	 * Only enabled when < 100 records are selected
	 * @private
	 */
	private downloadBtn: HTMLElement;

	/**
	 * Add to collection btn on batch
	 * Only enabled when < 100 records are selected
	 * @private
	 */
	private addToCollectionBtn: HTMLElement;

	/**
	 * Run workflow btn
	 * @private
	 */
	private runWorkflowBtn: HTMLElement;

	/**
	 * Edit metadata btn
	 * @private
	 */
	private editMetadataBtn: HTMLElement;

	/**
	 * Remove from collection button
	 * @private
	 */
	private removeBtn : HTMLElement;

	/**
	 *
	 * @private
	 */
	private keyDownEvent: any;

	/**
	 *
	 * @private
	 */
	private keyUpEvent: any;

	/**
	 *
	 * @private
	 */
	protected mouseMoveEvent: any;

	/**
	 *
	 * @private
	 */
	protected mouseClickEvent: any;

	/**
	 * All our preview items
	 * In relation to left click & drag to select many items
	 * @private
	 */
	protected previewItems: Array<HTMLElement> = [];


	/**
	 * The download item in the ctx menu for mobile
	 * @private
	 */
	private ctxItems: any;

	/**
	 * @param collection
	 * @protected
	 */
	constructor(collection: any) {
		super(collection.id, collection.title);

		this.collection = collection;
		this.selections.count = collection.numHits;

		if (this.id && this.collection.isAnonLink) {
			if (typeof this.id !== "number") {
				this.accessLink = this.id.replace('~', '');
			}
		}

		this.view();
	}

	/**
	 * Continue creating the view
	 * @protected
	 */
	protected view() {
		super.view();

		// we only want to show download if NOT a guest OR an anonymous access collection with download access
		if (this.canAnonAccess()) {
			this.downloadBtn = this.makeButton('download', 'download', iwi18n.gettext(undefined,'Download'), this.download);
			this.multiSelectMenu.appendChild(this.downloadBtn);
		}

		// other items only if NOT a guest
		if (!iw.isGuest) {
			this.addToCollectionBtn = this.makeButton('collection', 'collection-add', iwi18n.gettext('collections','Add to %1', iw.collectionsName), this.addToCollection);
			this.runWorkflowBtn = this.makeButton('workflow', 'workflow', iwi18n.gettext(undefined,'Run workflow'), this.runWorkflow);
			this.editMetadataBtn = this.makeButton('edit', 'edit', iwi18n.gettext(undefined,'Edit selected'), this.edit);
			this.removeBtn = this.makeButton('remove', 'clear', iwi18n.gettext(undefined,'Remove selected from %1', iw.collectionsName), this.remove);

			this.multiSelectMenu.appendChild(this.addToCollectionBtn);
			this.multiSelectMenu.appendChild(this.editMetadataBtn);
			this.multiSelectMenu.appendChild(this.runWorkflowBtn);

			if (!this.collection.smartId) {
				this.multiSelectMenu.appendChild(this.removeBtn);
				this.addEnquiryData();
			}
		}

		this.mainContainer.appendChild(this.createMobileCtx());

		iwToolTips.reInit();
	}

	/*
	 * Add collection enquiry forms to toolbar
	 */
	private addEnquiryData() {
		if (EnquiryData.data && !iwCore.isEmptyObject(EnquiryData.data)) {
			let parsedModel;
			for (let zoneId in EnquiryData.data) {
				if (EnquiryData.data.hasOwnProperty(zoneId)) {
					parsedModel = JSON.parse(EnquiryData.data[zoneId]);

					// only add forms where collections items are rendered to bulk toolbar
					// otherwise selecting collection items is meaningless
					if (parsedModel['collectionsEnabled']) {
						this.multiSelectMenu.appendChild(
							this.makeEnquireButton(
								'enquiry'+zoneId,
								'email',
								parsedModel['headerText'] || iwi18n.gettext(undefined, 'Enquire'),
								this.makeEnquiry.bind(this,zoneId),
								{
									iwcollectionid: this.collection.id,
									iwcollection_public_url: encodeURIComponent(this.collection.publicUrl),
									iwcollectionhits: this.collection.numHits,
									iwcollectionname: this.collection.title,
									iwdescription: this.collection.description,
									iwcreationdate: this.collection.rawCreationDate,
									iwmodifieddate: this.collection.rawModifiedDate
								}
							)
						);
					}
				}
			}
		}
	}

	/**
	 * Make a batch button specific for enquiries (the order in the CB has to be different to match context menu clicks)
	 * @param type
	 * @param iconClass
	 * @param tooltip
	 * @param cB
	 * @param params - optional - Html options
	 * @private
	 */
	private makeEnquireButton(type: string, iconClass: string, tooltip: string, cB: any, params?: any) {
		params = params || {};
		let btn = iwUI.createEl('BUTTON', {id: 'multi-select-' + type, class: 'multiSelect-menuItem multiSelect-menuItem--desktop iw_tool_tip_link ' + (params.class || ''), 'aria-label': params.ariaLabel ||''}),
			icon = iwUI.createEl('I', {class: 'iw-icon-' + iconClass});
		if (tooltip) {
			btn.setAttribute('data-tool-tip', tooltip);
		}

		EVENT.attach(btn, 'click', cB.bind(this, params, btn, this.selections.items));

		btn.appendChild(icon);
		return btn;
	}

	/**
	 *
	 * @param btn - Button element that was clicked
	 * @private
	 */
	private addToCollection(btn: HTMLElement) {
		CISCollectionsLink.fireMultiSelectRecordAdd(btn, this.selections.items);
	}

	/**
	 * Creates the mobile ctx menu, which when viewed in mobile will be under an elipsis in a ctx menu
	 * @private
	 */
	private createMobileCtx() {

		let params:any = {
			collectionid: this.collection.id,
			collection_public_url: encodeURIComponent(this.collection.publicUrl),
			collectionhits: this.collection.numHits,
			collectionname: this.collection.title,
			description: this.collection.description,
			creationdate: this.collection.rawCreationDate,
			modifieddate: this.collection.rawModifiedDate
		};

		if (this.collection.smartId) {
			params.smartid = this.collection.smartId;
		}

		let menu = iwMenu.createMenuLink('batchCtx', EnquiryData.getMenuData(params));

		menu.classList.add('multiSelect-menuItem', 'multiSelect-menuItem--responsiveMenu');

		this.ctxItems = {};
		let group: any[] = [];
		// we only want to show download if NOT a guest OR an anonymous access collection with download access
		if (this.canAnonAccess()) {
			this.ctxItems.download = {
				name: iwi18n.gettext(undefined, 'Download'),
				cbFn: () => this.download(menu, this.selections.items),
				icon: 'iw-icon-download'
			};

			group.push(this.ctxItems.download)
		}

		// other items only if NOT a guest
		if (!iw.isGuest) {
			this.ctxItems.collection = {
				name: iwi18n.gettext('collections', 'Add to %1', iw.collectionsName),
				cbFn: this.addToCollection.bind(this, menu),
				icon: 'iw-icon-collection-add'
			};

			this.ctxItems.edit = {
				name: iwi18n.gettext(undefined, 'Edit selected'),
				cbFn: () => this.edit,
				icon: 'iw-icon-edit'
			};

			this.ctxItems.runWorkflow = {
				name: iwi18n.gettext(undefined, 'Run workflow'),
				cbFn: this.runWorkflow.bind(this, menu),
				icon: 'iw-icon-workflow'
			};

			group.push(this.ctxItems.edit, this.ctxItems.collection, this.ctxItems.runWorkflow);

			if (!this.collection.smartId) {
				this.ctxItems.remove = {
					name: iwi18n.gettext(undefined, 'Remove selected from %1', iw.collectionsName),
					cbFn: () => this.remove(menu),
					icon: 'iw-icon-clear'
				}

				group.push(this.ctxItems.remove)
			}
		}

		iwMenu.setMenuArray('batchCtx', {
			groups: [
				[
					{
						name: iwi18n.gettext(undefined, "All"),
						cbFn: this.selectAll.bind(this),
						icon: 'iw-icon-select',
					},
					{
						name: iwi18n.gettext(undefined, "None"),
						cbFn: this.clearSelect.bind(this),
						icon: 'iw-icon-unselect',
					},
				],
				group,
				this.getEnquiryMenuGroup()
			]
		});

		return menu;
	}

	/**
	 * Add enquiry items to an existing menu group
	 */
	private getEnquiryMenuGroup() {
		// loop over all enquiry forms user has access too and create a context menu item for it
		let arr = [];
		if (EnquiryData.data && !iwCore.isEmptyObject(EnquiryData.data)) {
			let parsedModel;
			for (let zoneId in EnquiryData.data) {
				if (EnquiryData.data.hasOwnProperty(zoneId)) {
					parsedModel = JSON.parse(EnquiryData.data[zoneId]);
					// only add forms where collections items are rendered to bulk toolbar
					// otherwise selecting collection items is meaningless
					if (parsedModel['collectionsEnabled']) {
						let headerText = parsedModel.headerText || iwi18n.gettext(undefined, 'Enquire');
						if (headerText.length > 23) {
							headerText = headerText.substring(0, 20) + '...';
						}
						arr.push(
							{
								name: headerText,
								icon: 'iw-icon-email',
								cbFn: this.makeEnquiry.bind(this,zoneId),
								// each form has a unique condition
								condition: 'iwcanenquire_' + zoneId,
							}
						)
					}
				}
			}
		} else if (EnquiryData.isLegacy) {
			arr.push(
				{
					name: iwi18n.gettext(undefined, 'Enquire'),
					icon: 'iw-icon-email',
					cbFn: EnquiryData.enquire.bind(this,null),
					condition: 'iwcanenquire'
				}
			);
		}

		return arr;
	}

	/**
	 * Implementing the abstract method - see parent
	 * @protected
	 */
	protected onSelectionCallback() {
		let isOnlyClips = this.selections.items.filter((f: any) => f.isClip).length === this.selections.items.length,
			hasItemsToEdit = this.selections.items.filter((f: any) => f.canEditItem).length > 0,
			/**
			 * Disable and enable the record selection items in desktop view and mobile view for the context menu
			 * @param disable
			 * @param desktopBtn - the desktop button html element
			 * @param mobileCtxItem - the mobile ctx item
			 */
			disableEnableItems = (disable: boolean, desktopBtn: HTMLElement, mobileCtxItem: any) => {
				mobileCtxItem.disabled = disable;
				if (disable) {
					desktopBtn.setAttribute('disabled', 'disabled');
				} else {
					desktopBtn.removeAttribute('disabled');
				}
			};

		// check edit metadata
		if (this.editMetadataBtn) {
			let disableMetadata = !hasItemsToEdit;
			if (this.selections.isEntireHitList) {
				disableMetadata = false;
			}

			disableEnableItems(disableMetadata,
				this.editMetadataBtn, this.ctxItems.edit);
		}

		if (this.downloadBtn) {
			// check download
			let disableDownload = isOnlyClips;

			if (this.selections.isEntireHitList && (this.selections.items.length !== this.selections.count)) {
				disableDownload = false;
			}
			disableEnableItems(disableDownload,
				this.downloadBtn, this.ctxItems.download);
		}

		if (this.addToCollectionBtn) {
			// check add to collections
			disableEnableItems((this.selections.isEntireHitList && (this.selections.items.length !== this.selections.count)) || this.selections.items.length > 100,
				this.addToCollectionBtn, this.ctxItems.collection);
		}

		if (this.runWorkflowBtn) {
			// check run workflow
			let disableWorkflow = !hasItemsToEdit || !!this.collection.smartId;

			// if the entire hitlist is selected, allow run workflow so we can check the hidden items
			if (this.selections.isEntireHitList) {
				disableWorkflow = false;
			}
			disableEnableItems(disableWorkflow,
				this.runWorkflowBtn, this.ctxItems.runWorkflow);
		}
	}

	/**
	 *
	 * @param btn - Button element that was clicked
	 * @private
	 */
	private edit(btn: HTMLElement) {
		if (this.selections.isEntireHitList) {
			CollectionsViewer.getCollectionIds(this.collection.id,
				this.collection.smartId,
				null,
				BatchTypes.EDIT_RECORDS,
				(e: any) => {
					if (e.success) {
						if (e.items.length) {
							let items = JSON.parse(e.items);
							new BatchMetadata(items.map((m: any) => m.recordID));
						} else {
							iwNotifications.error(iwi18n.gettext(undefined, 'There are no valid records to edit. Please refresh the page and try again.'));
						}
					} else {
						iwNotifications.error(iwi18n.gettext('projects', 'There was an error retrieving records.'), iwi18n.gettext('projects', 'Error'));
					}
				}, iwi18n.gettext('projects', 'There was an error retrieving records.'));
		} else {
			new BatchMetadata(this.selections.items.map((m: any) => m.recordID));
		}
	}

	/**
	 * Only send off non-clips, if entire hitlist, fetch ids
	 * @param btn
	 * @param selections
	 * @protected
	 */
	protected download(btn: any, selections: any) {
		if (this.selections.isEntireHitList) {
			CollectionsViewer.getCollectionIds(this.collection.id, this.collection.smartId, null, BatchTypes.DOWNLOAD_MEDIA, (e: any) => {
				if (e.success) {
					if (e.items.length) {
						let items = JSON.parse(e.items);
						items = items.filter((f: any) => !(f.startFrame || f.endFrame));
						CISDownloadMedia.searchBatchDownload(btn, items.map((m: any) => m.recordID), this.accessLink, this.batchName, this.collection.id);
					} else {
						iwNotifications.error(iwi18n.gettext(undefined, 'There are no valid records to download. Please refresh the page and try again.'));
					}
				} else {
					iwNotifications.error(iwi18n.gettext('projects', 'There was an error retrieving records.'), iwi18n.gettext('projects', 'Error'));
				}
			}, iwi18n.gettext('projects', 'There was an error retrieving records.'));
		} else {
			super.download(btn, selections.filter((f: any) => !f.isClip));
		}
	}

	/**
	 *
	 * @param el
	 * @private
	 */
	private runWorkflow(el: HTMLElement) {
		let ids = [];
		if (!this.selections.isEntireHitList) {
			ids = this.selections.items.map((m: any) => m.clipID);
		}

		CollectionSelection.getIdsForWorkflow(el, this.collection, ids);
	}

	/*
	 * Make enquiry callback
	 * @param zoneId
	 * @param params
	 * @param el
	 */
	private makeEnquiry(zoneId: any,params: any, el: HTMLElement) {
		// we don't need to get ALL collection items for entiry hitlist, as backend code assume all items if selection is empty
		EnquiryData.enquire.call(this,zoneId,params,el,(this.selections.isEntireHitList ? [] : (this.selections.items.map((m: any) => { return {clipID : m.clipID} }))));
	}

	/**
	 *
	 * Remove items from collection
	 * @private
	 */
	private remove(el: HTMLElement) {
		let mName = 'remove-items',
			removeItems = (items: any) => {
				if (items.length > 0) {
					iwModal.create(el, mName, {
						title: iwi18n.gettext(undefined, 'Remove items'),
						type: 'delete',
						buttonLabel: iwi18n.gettext(undefined, 'Remove items'),
						buttonClick: () => {
							iwCore.ajax({
								type: 'POST',
								url: '/collections/removeitems',
								data: {
									items,
									collectionID: this.collection.id,
									type: BatchTypes.REMOVE_MEDIA
								},
								beforeSend: ()=> iwCore.loading(true),
								success: (e: any) => {
									if(e.success) {
										window.location.reload();
									} else {
										iwNotifications.error(iwi18n.gettext(undefined, 'Something went wrong, please try again later'));
									}

									iwCore.loading(false);
									iwModal.hide(mName);
								},
								error: () => {
									iwNotifications.error(iwi18n.gettext(undefined, 'Something went wrong, please try again later'));
									iwCore.loading(false);
									iwModal.hide(mName);
								}
							});
						}
					});
				} else {
					iwNotifications.error(iwi18n.gettext(undefined, 'No valid items selected. You may not have permission to remove these items from the collection.'));
				}
			}

		if (this.selections.isEntireHitList) {
			CollectionsViewer.getCollectionIds(this.collection.id, this.collection.smartId, null, BatchTypes.REMOVE_MEDIA, (e: any) => {
				if (e.success) {
					if (e.items.length) {
						removeItems(JSON.parse(e.items))
					} else {
						iwNotifications.error(iwi18n.gettext(undefined, 'Something went wrong, please try again later'));
					}
				} else {
					iwNotifications.error(iwi18n.gettext(undefined, 'Something went wrong, please try again later'));
				}
			}, iwi18n.gettext(undefined, 'Something went wrong, please try again later'));
		} else {
			removeItems(this.selections.items.map((m: any) => m.clipID));
		}
	}


	/**
	 *
	 * @param el - element clicked
	 * @param collection
	 * @param ids
	 */
	public static getIdsForWorkflow(el: HTMLElement, collection: any, ids: any) {
		CollectionsViewer.getCollectionIds(collection.id, null, ids, BatchTypes.RUN_WORKFLOW, (e) => {
			if (e.success && e.hasValidItems) {
				iwRunWorkflow(el,
					new RunWorkflowConfig(
						e.key,
						null,
						null,
						null,
						null,
						null,
						null,
						collection.title));
			} else {
				iwNotifications.error(iwi18n.gettext(undefined, 'No items available to run workflow on'), iwi18n.gettext('projects', 'Error'));
			}

		}, iwi18n.gettext(undefined, 'Something went wrong, please try again later'));
	}


	/**
	 * Can the user access the toolbar item
	 * @protected
	 * @return boolean
	 */
	protected canAnonAccess() {
		//  && this.collection.showDownload seem broke, always false. So not using for now
		return (!iw.isGuest || (iw.isGuest && this.id && this.collection.isAnonLink));
	}
}